import { useLogout } from '../hooks/useLogout';

/**
 * ログアウトページのContainer Component
 */
export const LogoutContainer: React.FC = () => {
  useLogout();
  return null;
};
